export default __webpack_public_path__ + "static/media/cycle-blur.c19d66de.png";